import { useQuery, type UseQueryResult } from '@tanstack/react-query';
import { ensureShoppingCart } from '@services/shoppingCartService';
import type { ShoppingCartDTO } from '@t/api.types';

export const cartQueryKey = (sessionId: string): readonly unknown[] => ['shoppingCart', sessionId];

export const useCart = (sessionId: string): UseQueryResult<ShoppingCartDTO, Error> =>
  useQuery<ShoppingCartDTO>({
    queryKey: cartQueryKey(sessionId),
    queryFn: () => ensureShoppingCart(sessionId),
    enabled: !!sessionId,
    staleTime: Infinity,
    refetchOnWindowFocus: false,
    refetchOnMount: false,
    refetchOnReconnect: false,
  });
